import { type SbBlokData, storyblokEditable } from '@storyblok/js';

export const editable = (node: HTMLElement, value: SbBlokData) => {
	const { setAttribute, removeAttribute, classList } = node;

	const updateDom = (value: SbBlokData) => {
		const options = storyblokEditable(value);
		if (options['data-blok-c']) {
			setAttribute.bind(node)('data-blok-c', options['data-blok-c']);
			setAttribute.bind(node)('data-blok-uid', options['data-blok-uid']);
			classList.add('storyblok__outline');
		}
	};

	updateDom(value);

	return {
		update: updateDom,
		destroy() {
			removeAttribute.bind(node)('data-blok-c');
			removeAttribute.bind(node)('data-blok-uid');
			classList.remove('storyblok__outline');
		}
	};
};
